module.exports = __webpack_public_path__ + "img/2-2.4e709d0a.png";